import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'

const CatholicHouseholdLazy = createLazyComponent(() => import('./CatholicHousehold'))

const CatholicHousehold = (props) => <CatholicHouseholdLazy {...props} />

export default CatholicHousehold
